module.exports = __webpack_public_path__ + "media/country_flags/uy-84484899.png";